export const INDIVIDUAL = 'individual_project';
export const GROUP = 'group_project';
export const QA = 'q_n_a';
export const INTERACTIVE_VIDEO = 'interactive_video';
